module.exports = __webpack_public_path__ + "img/currency-bitcoin-circle.7d9fa3e5.svg";